// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9edde9c6","977":"99dc5f88"}[chunkId] + ".chunk.js";
};